import { render, staticRenderFns } from "./InsightStatus.vue?vue&type=template&id=47c57476"
import script from "./InsightStatus.vue?vue&type=script&lang=js"
export * from "./InsightStatus.vue?vue&type=script&lang=js"
import style0 from "./InsightStatus.vue?vue&type=style&index=0&id=47c57476&prod&lang=scss&scpoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports